import { writable } from 'svelte/store';

export const metadataState = writable([]);